import React from 'react';
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import LoginPage from './components/Login.js';
import LogoutPage from './components/Logout.js';
import SignUpForm from './components/SignUp.js';
import ProfilePage from './components/Profile.js';
import LandingPage from './components/LandingPage.js';
import ProtectedRoute from './common/ProtectedRoute';
import Spaces from './components/Spaces';
import Space from './components/Space';
import NavBar from './common/Navbar';
import SubscriptionsPage from './components/Subscriptions.js';
import NavBarLandingPage from './common/NavbarLandingPage.js';
import TermsOfUse from './components/Terms.js';
import PrivacyPolicy from './components/PrivacyPolicy.js';
import { SpaceContextProvider } from './common/SpaceContextProvider.js';
import { useAuth } from './common/AuthProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';


export const App = () => {

  const { isAuthenticated } = useAuth();

  return (
    <div className={`App-container ${ isAuthenticated ? 'flex-row' : 'flex-col'}`}>
    <Router>
        { isAuthenticated  ? <NavBar/> : <NavBarLandingPage/> }
          <Switch>
            <Route path="/" exact> <LandingPage /> </Route>
            <Route path="/login" exact> <LoginPage /> </Route>
            <Route path="/sign-up" exact> <SignUpForm /> </Route>
            <Route path="/terms" exact> <TermsOfUse /> </Route>
            <Route path="/privacy" exact> <PrivacyPolicy /> </Route>
            <Route path="/plans"> <SubscriptionsPage /> </Route>
              <ProtectedRoute allowWithoutSubscription={true} path="/profile"> <ProfilePage /> </ProtectedRoute>
              <ProtectedRoute allowWithoutSubscription={false} path="/spaces" exact> <Spaces/> </ProtectedRoute>
              <ProtectedRoute allowWithoutSubscription={true} path="/logout"> <LogoutPage /> </ProtectedRoute>
              <ProtectedRoute allowWithoutSubscription={false} path="/spaces/:id" exact> 
                <SpaceContextProvider>
                  <Space />
                </SpaceContextProvider>
            </ProtectedRoute> 
            <Route path="*"><Redirect to="/" /> </Route>
          </Switch>
      </Router>
      </div>
  );
}

export default App;
